var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5195_133332",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5195_133332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5449 12L15.7422 7.80269C15.9395 7.60538 16.0381 7.35426 16.0381 7.04933C16.0381 6.74439 15.9395 6.49327 15.7422 6.29596C15.5449 6.09865 15.2938 6 14.9888 6C14.6839 6 14.4328 6.09865 14.2355 6.29596L9.28478 11.2466C9.06954 11.4619 8.96191 11.713 8.96191 12C8.96191 12.287 9.06954 12.5381 9.28478 12.7534L14.2355 17.704C14.4328 17.9013 14.6839 18 14.9888 18C15.2938 18 15.5449 17.9013 15.7422 17.704C15.9395 17.5067 16.0381 17.2556 16.0381 16.9507C16.0381 16.6457 15.9395 16.3946 15.7422 16.1973L11.5449 12Z",
    fill: "#1E1531"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowLeft);
export default __webpack_public_path__ + "static/media/keyboard_arrow_left.323228ce7972e17e059d19e96b2369fe.svg";
export { ForwardRef as ReactComponent };